import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete_new';
import {
  AppContext,
  BackgroundIcon,
  Close,
  getTranslatedText,
  isAuthorised,
  useUserMSPCheckHook,
  settingsModuleObj,
  isFeatureAuthorisedInPlan,
  COMMON_CONSTANTS
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import { Avatar, Button } from '@superops/ui-design-system';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { cloneDeep, isEmpty } from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { useCheckFeatureGating } from '@nile/components/src/HOC/withPlanFeatureGating';
import { isProductAuthorised } from '@nile/components/src/Utils/helpers';
import { FEATURE_GATING_STATUS } from '@nile/components';

function SettingsPage(props) {
  const { flags, intl } = props;
  const appContext = useContext(AppContext);
  const { currentProduct } = appContext;
  const homeContext = useContext(HomeContext);
  const { user } = appContext;
  const agentFeatures = user?.rmmAppProperties?.betaAgentBasedFeatures;
  const browser = homeContext.getBrowserType();
  const isMSP = useUserMSPCheckHook();

  const showNetworkView = useCheckFeatureGating('network-monitoring-system');
  const isWindowsManagement = useCheckFeatureGating('WINDOWS_MANAGEMENT');
  const [textFieldValue, setTextFieldValue] = useState('');
  const loadRMMAppProperties =
    appContext?.rmmProperties['rmm.policyManagementType'];

  const handleAutoCompleteChange = useCallback((value) => {
    setTextFieldValue(value.label);
    handleCreation(value);
  }, []);

  const handleTextFieldChange = useCallback((value) =>
    setTextFieldValue(value)
  );

  const handleCreation = (mod) => {
    const currentAppState = homeContext?.userAppState || { appState: [] };
    const updatedAppState = cloneDeep(currentAppState.appState);
    let tab = {
      id: 'onboard-tab',
      content: '',
      module: 'ONBOARD',
      tabId: 'onboard-tab',
      state: {},
      data: {}
    };
    let tabIdx = updatedAppState.findIndex((el) => el.id === 'onboard-tab');
    tab.url = mod.url;
    if (mod.tabname) tab.state = { tabname: mod.tabname };
    if (tabIdx === -1) {
      updatedAppState.push(tab);
    } else {
      updatedAppState[tabIdx] = tab;
    }
    homeContext.updateUserAppState({
      ...currentAppState,
      appState: updatedAppState,
      activeTabIndex: updatedAppState.findIndex((el) => el.id === tab.id)
    });
    homeContext.closeSettingsOverlay(true);
    setTimeout(() => {
      homeContext.switchTabFocus(tab);
    }, 200);
  };
  const reference = user?.role?.roleFeatureList || [];

  // need to refactor this with backend object
  let planNameConnect = '';
  let planNameStandardRmm = '';
  let planNameGrow = '';
  let planNameStandardPsa = '';
  let planNameRise = '';
  if (flags?.connectPlan) {
    planNameConnect = 'connect';
    planNameStandardRmm = 'standard-rmm';
    planNameGrow = 'grow';
    planNameStandardPsa = 'standard-psa';
    planNameRise = 'rise';
  }
  const planId = user?.chargeBeePlanId.toLowerCase();

  const settingsListObj = settingsModuleObj({
    intl: intl,
    flags: flags,
    isMSP: isMSP,
    userDetail: user,
    appContext: appContext,
    currentProduct,
    loadRMMAppProperties
  });
  const setKeyMod = Object.values({
    ...settingsListObj,
    mspSettingsList: {
      ...settingsListObj?.mspSettingsList,
      //Checking for the product IT or MSP and renaming the label according to product
      data: settingsListObj?.mspSettingsList?.data.map((item) => {
        if (item.name === 'employees') {
          return {
            ...item,
            label: getTranslatedText(
              intl,
              currentProduct === COMMON_CONSTANTS.IT
                ? 'common.users'
                : 'admin.stepnavi.employee'
            )
          };
        }
        return item;
      })
    }
  });

  const profileList = [
    {
      label: getTranslatedText(intl, 'admin.stepnavi.profileInfo'),
      icon: 'employees',
      url: '/onboard/profile',
      svgIcon: 'Employee'
    },
    {
      label: getTranslatedText(intl, 'admin.stepnavi.twoFactorAuthentication'),
      icon: 'TFA',
      url: '/onboard/profile',
      tabname: 'security',
      svgIcon: 'Tfa'
    },
    {
      name: 'billingAndInvoice',
      label: getTranslatedText(intl, 'admin.stepnavi.billing&Invoice'),
      url: '/onboard/billing',
      svgIcon: 'BillingAndInvoice'
    }
  ];

  if (isMSP) {
    profileList.push({
      label: getTranslatedText(intl, 'admin.myprofile.h2.apitoken'),
      icon: 'code',
      url: '/onboard/profile',
      tabname: 'apitoken',
      svgIcon: 'Code'
    });
  }

  const mspSettingsList = [
    {
      name: 'mspInformation',
      label: getTranslatedText(intl, 'admin.stepnavi.mspdetails'),
      url: '/onboard/mspinformation',
      svgIcon: 'MspInformation'
    },
    {
      name: 'mailSettings',
      label: getTranslatedText(intl, 'admin.stepnavi.emailserver'),
      url: '/onboard/mailserver',
      svgIcon: 'MailSettings'
    },
    {
      name: 'employees',
      label: getTranslatedText(intl, 'admin.stepnavi.employee'),
      url: '/onboard/employee',
      svgIcon: 'Employee'
    },
    {
      name: 'holidayList',
      label: getTranslatedText(intl, 'admin.stepnavi.holiday'),
      url: '/onboard/holidaylist',
      show: true,
      svgIcon: 'HolidayList'
    },
    {
      name: 'onboardingNotificationTemplate',
      label: getTranslatedText(
        intl,
        'settings.stepNav.notificationCenter.title'
      ),
      url: '/onboard/notificationcenter',
      svgIcon: 'OnboardingNotificationTemplate'
    },
    {
      url: '/onboard/aifeatures',
      label: getTranslatedText(intl, 'settings.stepNav.aiFeatures.title'),
      name: 'aiFeature',
      permission: 'allow',
      svgIcon: 'AiSparkleOutline',
      featureGateName: 'AI_FEATURES'
    }
  ];

  const contractAndBillingList = [
    {
      name: 'serviceCatalog',
      label: getTranslatedText(intl, 'admin.stepnavi.serviceCatalog'),
      url: '/onboard/serviceCatalog',
      svgIcon: 'ServiceCatalog'
    },
    {
      name: 'tax',
      label: getTranslatedText(intl, 'admin.stepnavi.tax'),
      url: '/onboard/tax',
      svgIcon: 'Tax'
    }
  ];

  if (isMSP) {
    contractAndBillingList.push(
      {
        url: '/onboard/timetracking',
        label: getTranslatedText(intl, 'admin.stepnavigation.timeTracking'),
        name: 'serviceCatalog',
        id: 'timeTracking',
        icon: 'worklog',
        svgIcon: 'Worklog'
      },
      {
        url: '/onboard/contractTemplate',
        label: getTranslatedText(intl, 'Contract Templates'),
        name: 'contractTemplate',
        svgIcon: 'Contract',
        permission: 'view'
      }
    );
  }

  if (isMSP) {
    contractAndBillingList.push({
      url: '/onboard/invoicesettings',
      label: getTranslatedText(
        intl,
        flags?.quote
          ? 'admin.stepnavi.quoteAndInvoice.settings'
          : 'admin.stepnavi.invoice.settings'
      ),
      // name: 'invoiceSettings',
      icon: 'invoice-logo',
      svgIcon: 'InvoiceLogo'
    });
  }

  const accessControlList = [
    {
      name: 'role',
      label: getTranslatedText(intl, 'admin.stepnavi.techRole'),
      icon: 'techLogin',
      url: '/onboard/technicianrole',
      svgIcon: 'Employee'
    },
    {
      name: 'role',
      label: getTranslatedText(intl, 'admin.stepnavi.requesterRole'),
      icon: 'requesterLogin',
      url: '/onboard/userrole',
      svgIcon: 'RequesterLogin'
    },
    {
      name: 'technicianGroup',
      label: getTranslatedText(intl, 'admin.stepnavi.techgroup'),
      url: '/onboard/techniciangroup',
      svgIcon: 'TechnicianGroup'
    }
  ];
  const ticketSettingList = [
    {
      name: 'status',
      label: getTranslatedText(intl, 'common.status'),
      url: '/onboard/ticketstatus',
      svgIcon: 'TicketOutline',
      permissionToCheck: 'customFields.view'
    },
    {
      name: 'impactUrgencyPriority',
      label: getTranslatedText(intl, 'admin.stepnavi.impUrgPri'),
      url: '/onboard/impacturgencypriority',
      svgIcon: 'ImpactUrgencyPriority',
      permissionToCheck: 'customFields.view'
    }
  ];

  const slaList = [
    {
      name: 'slaPolicy',
      label: getTranslatedText(intl, 'admin.stepnavi.slapolicy'),
      url: '/onboard/sla',
      svgIcon: 'HourglasswireEnd'
    },
    {
      name: 'slaMetric',
      label: getTranslatedText(intl, 'admin.stepnavi.slametric'),
      url: '/onboard/slametric',
      svgIcon: 'SlaMetric'
    }
  ];
  const automationRulesList = [
    {
      name: 'eventTriggers',
      label: getTranslatedText(intl, 'admin.stepnavi.eventTrigger'),
      url: '/onboard/eventtriggers',
      svgIcon: 'EventTriggers'
    },
    {
      name: 'timeTriggers',
      label: getTranslatedText(intl, 'admin.stepnavi.timetrigger'),
      url: '/onboard/timetriggers',
      svgIcon: 'TimeTriggers'
    },
    {
      name: 'ticketScheduler',
      flag: 'ticketScheduler',
      label: getTranslatedText(intl, 'admin.stepnavi.ticketScheduler'),
      url: '/onboard/ticketSchedulers',
      svgIcon: 'TicketScheduler'
    }
  ];
  const assetSettingsList = [
    {
      name: 'assetCustomFields',
      label: getTranslatedText(intl, 'admin.stepnavi.asset'),
      url: '/onboard/assetclass',
      svgIcon: 'Quantity'
    },
    {
      name: 'policySet',
      label: getTranslatedText(intl, 'admin.stepnavi.policy'),
      url: '/onboard/policymgmt-new',
      svgIcon: 'PolicyLight'
    },
    {
      url: '/onboard/it-documentation',
      label: getTranslatedText(intl, 'admin.stepnavi.it.documentation'),
      name: 'itDocumentationCategory',
      icon: 'it-documentation-icon',
      svgIcon: 'ItDocumentationIcon'
    },
    {
      url: '/onboard/systemtray',
      label: getTranslatedText(intl, 'admin.stepnavi.system.tray.icon'),
      name: 'systemTrayIcon',
      svgIcon: 'SystemTrayIcon'
    }
  ];

  if (
    flags.networkEndpointAsset ||
    showNetworkView?.enabled ||
    showNetworkView?.upsell
  ) {
    assetSettingsList.push({
      name: 'assetCustomFields',
      label: getTranslatedText(intl, 'snmp.credential.definition'),
      url: '/onboard/credential',
      svgIcon: 'Credential'
    });
  }

  if (flags.windowsPatchManagement) {
    assetSettingsList.push({
      url: '/onboard/softwarebundle',
      label: getTranslatedText(intl, 'admin.stepnavi.software.bundle'),
      name: 'softwareBundle',
      icon: 'software_bundle',
      svgIcon: 'SoftwareBundle'
    });
  }
  // if (flags?.frontendPolicyRevamp && isWindowsManagement?.enabled) {
  //   assetSettingsList.splice(2, 0, {
  //     url: '/onboard/devicecategory',
  //     label: getTranslatedText(intl, 'Device Category'),
  //     name: 'assetCustomFields',
  //     svgIcon: 'PolicyLight'
  //   });
  // }
  if (flags?.globalPatch && isWindowsManagement?.enabled) {
    assetSettingsList.splice(3, 0, {
      url: '/onboard/globalpatch',
      label: getTranslatedText(
        intl,
        'admin.policyManagement.globalpatch.header'
      ),
      name: 'policySet',
      svgIcon: 'PolicyLight'
    });
  }

  const advancedCustomizationList = [
    {
      label: getTranslatedText(intl, 'admin.stepnavi.identificationNumbers'),
      url: '/onboard/identificationNumbers',
      svgIcon: 'Numbers',
      flag: 'identificationNumbers',
      name: 'identificationNumbers'
    },
    {
      label: getTranslatedText(intl, 'admin.stepnavi.templates'),
      url: '/onboard/templates',
      icon: 'tasks',
      svgIcon: 'Tasks'
    },
    {
      name: 'runbook',
      label: getTranslatedText(intl, 'admin.stepnavi.runbooks'),
      url: '/onboard/sop',
      svgIcon: 'Runbook'
    },
    {
      name: 'customerSatisfacationSurvey',
      label: getTranslatedText(intl, 'admin.stepnavi.customer'),
      url: '/onboard/css',
      svgIcon: 'CustomerSatisfacationSurvey'
    }
  ];

  advancedCustomizationList.splice(2, 0, {
    url: '/onboard/manageFields',
    label: getTranslatedText(intl, 'admin.stepnavi.manageFields'),
    name: 'customFields',
    icon: 'CustomFields',
    svgIcon: 'CustomFields'
  });

  const generalSettingsList = [
    {
      name: 'securitySettings',
      label: getTranslatedText(intl, 'admin.stepnavi.techLogin'),
      icon: 'techLogin',
      url: '/onboard/technicianlogin',
      svgIcon: 'Employee'
    },
    {
      name: 'securitySettings',
      label: getTranslatedText(intl, 'admin.stepnavi.requesterLogin'),
      icon: 'requesterLogin',
      url: '/onboard/requesterlogin',
      svgIcon: 'RequesterLogin'
    },
    {
      name: 'securitySettings',
      label: getTranslatedText(intl, 'admin.stepnavi.session'),
      icon: 'session',
      url: '/onboard/sessionsettings',
      svgIcon: 'Session'
    },
    {
      name: 'securitySettings',
      label: getTranslatedText(intl, 'admin.stepnavi.IPaddress'),
      icon: 'IPaddress',
      url: '/onboard/ipconf',
      svgIcon: 'IpAddress'
    }
  ];

  if (isWindowsManagement?.enabled && agentFeatures?.uninstallProtection) {
    generalSettingsList.unshift({
      name: 'securitySettings',
      label: getTranslatedText(intl, 'admin.stepnavi.agentprotection'),
      icon: 'Lock',
      url: '/onboard/agentuninstall',
      svgIcon: 'Lock'
    });
  }

  const othersList = [
    {
      name: 'integrations',
      label: getTranslatedText(intl, 'admin.stepnavi.integrations'),
      url: '/onboard/integrations',
      svgIcon: 'Integration'
    },
    {
      name: 'supportAccess',
      label: getTranslatedText(intl, 'admin.stepnavi.customerSupportAccess'),
      url: '/onboard/supportAccess',
      permission: 'allow',
      svgIcon: 'SupportAccess'
    },
    {
      name: 'boucedEmails',
      label: getTranslatedText(intl, 'common.bouncedEmails'),
      url: '/onboard/bouncedEmails',
      svgIcon: 'BouncedEmail',
      permissionToCheck: 'mailSettings.view',
      permission: 'view'
    }
  ];

  const psaOnlyGrow = [
    { name: 'profile' },
    { name: 'my msp' },
    { name: 'contract and billing' },
    { name: 'roles and groups' },
    { name: 'ticketing settings' },
    { name: 'service level agreements' },
    { name: 'automation' },
    { name: 'advanced configuration' },
    { name: 'security management' },
    { name: 'others' }
  ];

  const rmmOnly = [
    { name: 'profile' },
    { name: 'my msp' },
    { name: 'roles and groups' },
    { name: 'asset management' },
    { name: 'advanced configuration' },
    { name: 'security management' },
    { name: 'others' }
  ];
  const removeSettingListItem = [
    {
      category: 'my msp',
      show: 'mspInformation'
    },
    {
      category: 'my msp',
      show: 'employees'
    },
    {
      category: 'my msp',
      show: 'mailSettings'
    },
    {
      category: 'my msp',
      show: 'onboardingNotificationTemplate'
    }
  ];

  const removeSettingListItemAdvance = [
    {
      category: 'advanced configuration',
      show: ['customFields', 'manageFields']
    }
  ];

  function authoriseList(list) {
    return list.filter((el) => {
      if (el?.flag && !flags[el?.flag]) {
        return false;
      }
      if (!el.name || !el?.permission) return true;
      const permissionToCheck =
        el?.permissionToCheck || `${el.name}.${el.permission || 'view'}`;
      const isFeatureAuthorised = isAuthorised(reference, permissionToCheck);
      if (isFeatureAuthorised && el.name === 'billingAndInvoice') {
        if (user?.subscriptionStatus) {
          return true;
        }
        return false;
      }

      return isFeatureAuthorised;
    });
  }

  const rmmOnlyList = mspSettingsList.filter((el) => {
    return removeSettingListItem.some((f) => {
      return f.show === el.name;
    });
  });

  const rmmOnlyListAdvance = advancedCustomizationList.filter((el) => {
    return removeSettingListItemAdvance.some((f) => {
      return f.show.includes(el.name);
    });
  });
  const checkForProduct = (settingsProduct) => {
    if (
      settingsProduct &&
      !isProductAuthorised(currentProduct, settingsProduct)
    ) {
      return true;
    }
    return false;
  };

  const getAuthorisedList = (list) => {
    let authorisedModuleList = [];
    list.map((moduleSet) => {
      if (checkForProduct(moduleSet.productToCheck)) {
        return false;
      }
      const authorisedDataList = moduleSet.data.filter((el) => {
        if (checkForProduct(el.productToCheck)) {
          return false;
        }
        const permissionToCheck =
          el?.permissionToCheck ||
          (el?.name ? `${el.name}.${el.permission || 'view'}` : false);
        let isFeatureAuthorised = false;

        if (el?.onlyInModal && isAuthorised(reference, permissionToCheck)) {
          return true;
        }
        if (el?.flag && !flags[el?.flag]) {
          return false;
        }

        if (
          isAuthorised(reference, permissionToCheck) &&
          el.name === 'billingAndInvoice'
        ) {
          if (user.subscriptionStatus) {
            return true;
          }
        }

        if (el?.featureGateName) {
          const planAuthorised = isFeatureAuthorisedInPlan(
            el?.featureGateName,
            {
              trialEligible: el?.trialEligible,
              isDataCleanupRequired: el?.isDataCleanupRequired
            }
          );
          if (permissionToCheck) {
            isFeatureAuthorised = isAuthorised(reference, permissionToCheck);
            return planAuthorised && isFeatureAuthorised;
          }
          if (el.authorisation) {
            isFeatureAuthorised = el.authorisation.reduce(
              (acc, role) => isAuthorised(reference, `${role}.view`) || acc,
              false
            );
            return planAuthorised && isFeatureAuthorised;
          }

          return planAuthorised;
        }

        if (!el?.featureGateName && el.authorisation) {
          isFeatureAuthorised = el.authorisation.reduce(
            (acc, role) => isAuthorised(reference, `${role}.view`) || acc,
            false
          );
          return isFeatureAuthorised;
        }

        if (!el?.featureGateName && permissionToCheck) {
          isFeatureAuthorised = isAuthorised(reference, permissionToCheck);
          return isFeatureAuthorised;
        }

        if (!el.name) return true;
        if (!el.featureGateName) return true;

        return isFeatureAuthorised;
      });
      const updatedListObj = { ...moduleSet };
      if (authorisedDataList.length > 0) {
        updatedListObj.data = authorisedDataList;
        authorisedModuleList = [...authorisedModuleList, updatedListObj];
      }
    });

    return authorisedModuleList;
  };
  const newList = getAuthorisedList(setKeyMod);

  const settingsList = [
    {
      name: 'profile',
      title: user.firstName + ' ' + user.lastName,
      list: authoriseList(profileList)
    },
    {
      title: <FormattedMessage id="app.settings.mspsettings" />,
      list: authoriseList(
        planId === planNameConnect || planId === planNameStandardRmm
          ? rmmOnlyList
          : mspSettingsList
      ),
      name: 'my msp'
    },
    {
      title: <FormattedMessage id="app.settings.contractAndBilling" />,
      list: authoriseList(contractAndBillingList),
      name: 'contract and billing'
    },
    {
      title: <FormattedMessage id="app.settings.access" />,
      list: authoriseList(accessControlList),
      name: 'roles and groups'
    },
    {
      title: <FormattedMessage id="app.settings.ticketing" />,
      list: authoriseList(ticketSettingList),
      name: 'ticketing settings'
    },
    {
      title: <FormattedMessage id="app.settings.service" />,
      list: authoriseList(slaList),
      name: 'service level agreements'
    },
    {
      title: <FormattedMessage id="app.settings.automation" />,
      list: authoriseList(automationRulesList),
      name: 'automation'
    },
    {
      title: <FormattedMessage id="app.settings.assetmanagement" />,
      list: authoriseList(assetSettingsList),
      name: 'asset management'
    },
    {
      title: <FormattedMessage id="app.settings.advanced" />,
      list: authoriseList(
        planId === planNameConnect || planId === planNameStandardRmm
          ? rmmOnlyListAdvance
          : advancedCustomizationList
      ),
      name: 'advanced configuration'
    },
    {
      title: <FormattedMessage id="app.settings.security" />,
      list: authoriseList(generalSettingsList),
      name: 'security management'
    },
    {
      title: <FormattedMessage id="app.settings.others" />,
      list: authoriseList(othersList),
      name: 'others'
    }
  ];

  const getHighlightedText = (text, highlight) => {
    if (text) {
      const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
      return parts.map((part, i) => {
        return part.toLowerCase() === highlight.toLowerCase() ? (
          <HighLight>{part}</HighLight>
        ) : (
          part
        );
      });
    }
    return text; //to handle emply labels
  };

  function processData(rawData, IDKey, LabelKey) {
    const processedList = [];
    rawData.forEach((item) => {
      const x = {
        label:
          item[LabelKey] ||
          item.label ||
          item.name ||
          item.formName ||
          item.title,
        value:
          item[LabelKey] ||
          item.label ||
          item.name ||
          item.formName ||
          item.title,
        id: item[IDKey],
        ...item
      };
      processedList.push(x);
    });
    return processedList;
  }

  const optionsList = newList.map((set) => set.data).flat();
  const processedOptionsList = optionsList.map((opt) => {
    return { ...opt };
  });

  const FilteredSettingsList = [];
  const ModifiedSettingsList = [];

  newList.map((setting, i) => {
    const ModifiedSetting = { ...setting };
    ModifiedSetting.data.map((values) => {
      if (
        textFieldValue.length > 2 &&
        values.label.toLowerCase().includes(textFieldValue.toLowerCase())
      ) {
        values.label = getHighlightedText(values.label, textFieldValue);
        FilteredSettingsList.push(setting.title);
      }
    });
    ModifiedSettingsList.push(ModifiedSetting);
  });
  let renderRmmOnly = [];
  if (planId === planNameConnect || planId === planNameStandardRmm) {
    renderRmmOnly = newList.map((settings, i) => {
      const showList = rmmOnly.some((f) => {
        return settings?.name === f.name;
      });
      return showList && settings;
    });
    renderRmmOnly = renderRmmOnly.filter((item, index) => !isEmpty(item));
  }

  if (
    planId === planNameGrow ||
    planId === planNameStandardPsa ||
    planId === planNameRise
  ) {
    renderRmmOnly = settingsList.map((settings, i) => {
      const showList = psaOnlyGrow.some((f) => {
        return settings?.name === f.name;
      });
      return showList && settings;
    });
    renderRmmOnly = renderRmmOnly.filter((item, index) => !isEmpty(item));
  }

  let settingsListSelector =
    textFieldValue.length > 2
      ? ModifiedSettingsList
      : planId === planNameConnect ||
        planId === planNameStandardRmm ||
        planId === planNameGrow ||
        planId === planNameStandardPsa ||
        planId === planNameRise
      ? renderRmmOnly
      : settingsList;
  return (
    <HomeScreen browser={browser} className="sops-overlay-wrap">
      <Header className="sops-overlay-header">
        <Greeting className="sops-greating-text sops-row-wrap">
          <AutoComplete
            uniqueId="settingssOverlay"
            handleAutoCompleteChange={handleAutoCompleteChange}
            handleTextFieldChange={handleTextFieldChange}
            options={processData(processedOptionsList, 'label', 'label')}
          />
        </Greeting>
        <Actions>
          <Button
            onClick={() => {
              homeContext.closeSettingsOverlay(true);
            }}
            plain
          >
            <Close />
          </Button>
        </Actions>
      </Header>
      <SopsModuleWrap className="sops-module-wrap-height">
        <SopsInnerWrap className="sops-settings-wrap">
          {newList.length > 0 ? (
            newList.map((settings, i) => (
              <Categories
                className={`sops-settings-categories ${
                  FilteredSettingsList.includes(settings.title) ? 'active' : ''
                } `}
                style={{ animationDelay: (i + 1) * 0.1 + 's' }}
              >
                <ModuleSub className="sops-sub-head">
                  {settings.title}
                </ModuleSub>
                {settings.name && settings.name === 'profile' ? (
                  <ProfilePic
                    className={`profile-avatar ${user?.firstName.slice(0, 1)}`}
                  >
                    <Avatar
                      name={user?.firstName}
                      initials={user?.firstName.slice(0, 1).toUpperCase()}
                      size="large"
                      // source={Chris}
                    />
                  </ProfilePic>
                ) : null}
                {settings.data.map((el, i) => {
                  let upSellFeature = false;
                  let hasFeatureEnabled;
                  if (el?.featureGateName) {
                    const feature = useCheckFeatureGating(el?.featureGateName);
                    upSellFeature =
                      feature?.upsell ||
                      feature?.status === FEATURE_GATING_STATUS.IN_TRIAL ||
                      feature?.status === FEATURE_GATING_STATUS.EXPIRED;
                    // Skip enabled check if custom visibility logic was already applied
                    if (!el?.skipFeatureGateCheck) {
                      hasFeatureEnabled = feature?.enabled;
                    }
                  }

                  if (hasFeatureEnabled === false) {
                    return null;
                  }

                  return (
                    <Setting onClick={handleCreation.bind(this, el)}>
                      {el.svgIcon ? (
                        <div
                          className={`flex ${
                            el?.svgIgnoreOverride ? 'ignoreOverride' : ''
                          }`}
                        >
                          <SVGIcon name={el.svgIcon} />
                        </div>
                      ) : (
                        <BackgroundIcon
                          url={`url(${envConfig.imageRoot}svg/admin/${el.icon ||
                            el.name}.svg)`}
                        />
                      )}
                      <div className="ml8">{el.label}</div>
                      {upSellFeature && (
                        <div className="ml-10 flex actr">
                          <SVGIcon name="Crown" size="sm" color="#FFB915" />
                        </div>
                      )}
                    </Setting>
                  );
                })}
              </Categories>
            ))
          ) : (
            <div>No Results</div>
          )}
        </SopsInnerWrap>
      </SopsModuleWrap>
    </HomeScreen>
  );
}

const Header = styled.div`
  display: flex;
  align-items: center;
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: 10px;
`;

const Actions = styled.div`
  margin-left: auto;
  display: flex;
  button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff33;
    span,
    span svg {
      width: 20px;
      height: 20px;
    }
    &:hover {
      background-color: #ffffff;
    }
  }
`;

const HomeScreen = styled.div`
  background: ${(props) =>
    props.browser === 'Mozilla Firefox'
      ? 'var(--sops-settings-overlay-firefox-bg)'
      : 'var(--sops-settings-overlay-bg)'};
  backdrop-filter: blur(80px);
  padding: 20px 0px;
  height: 100vh;
  .module-logo {
    height: 56px;
    width: 64px;
  }
`;
const Greeting = styled.div`
  line-height: 63px;
  font-weight: normal;
  font-size: 30px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  margin-top: 20px;

  & > div {
    background: var(--sops-white-to-grey-bg);
    height: 60px;
    width: 75%;
    max-width: 900px;
    border-radius: 10px;
    margin: 0 auto;
  }

  .Polaris-TextField {
    margin: auto;
    margin-bottom: 0 !important;
    position: relative;
  }

  .Polaris-TextField__Backdrop,
  .Polaris-TextField__Backdrop:focus {
    display: none;
  }

  .Polaris-TextField__Prefix {
    left: calc(50% - 100px);
    opacity: 0.4;
    padding-left: 20px;
    position: absolute;

    .module-logo {
      width: 28px;
      height: 28px;
    }
  }

  .Polaris-TextField--focus {
    .Polaris-TextField__Prefix {
      left: 0 !important;
      opacity: 1;
    }
    input {
      text-align: left !important;
      padding-left: 60px !important;
    }
  }

  input {
    text-align: center;
    height: 60px;
    width: 100%;
    padding-left: 0px !important;
    font-size: 20px !important;
    line-height: 24px !important;
  }

  .Polaris-TextField__ClearButton {
    position: absolute;
    right: 15px;
  }
`;
const ModuleSub = styled.div`
  line-height: 30px;
  font-weight: 700;
  font-size: 24px;
  padding: 0;
  margin-bottom: 20px;
  margin-left: 10px;
`;
const Categories = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding: 40px;
  background: var(--sops-settings-category-card-bg);
  align-items: start;
  flex-grow: 1;
  flex-basis: 30%;
  min-width: 354px;
  min-height: 354px;
  max-width: 32%;
  overflow: auto;
  box-shadow: 0px 2px 22px rgba(0, 0, 0, 0.05);
  opacity: 0;
  transform: translate(0, -10%);
  transition: width 0.5s;
  animation: 0.65s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
  animation-name: homeHeroText;
  position: relative;

  &:hover {
    background: #ffffff;
  }
`;

const SopsModuleWrap = styled.div`
  width: 100%;
  overflow-y: auto;
  height: calc(100vh - 140px);
`;

const SopsInnerWrap = styled.div`
  width: 100%;
  margin: 40px auto 0;
  padding: 0 50px 100px;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
`;

const Setting = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  transition: all 0.1s ease-in;
  padding: 10px;
  border-radius: 10px;
  margin: 0 auto;

  &:hover {
    background: #f2f2f2;
  }
`;

const ProfilePic = styled.div`
  position: absolute;
  top: 18px;
  right: 40px;
  margin: 0;
`;

const HighLight = styled.span`
  background: #edab00;
`;

export default injectIntl(withRouter(withLDConsumer()(SettingsPage)));
